<template>
    <div class="geneticReport" @click="showExist = false">
      <i class="iconfont iconfanhui back" @click.stop="$router.push({path: '/genetic'})">返回</i>
      <van-icon class="bars" name="bars" color="#3A75B4" size="0.175rem" @click.stop="showExist = !showExist"/>
      <SideBar :show="showExist"></SideBar>
      <div class="listBox">
        <div class="list">
          <p class="title">您携带了增加心血管个疾病发生风险的相关突变：</p>
          <h1 class="disease_name">疾病名称</h1>
          <van-grid :column-num="2">
            <van-grid-item>基因</van-grid-item>
            <van-grid-item></van-grid-item>
          </van-grid>
          <van-grid :column-num="2">
            <van-grid-item>位点</van-grid-item>
            <van-grid-item></van-grid-item>
          </van-grid>
          <van-grid :column-num="2">
            <van-grid-item>检测基因型</van-grid-item>
            <van-grid-item></van-grid-item>
          </van-grid>
          <van-grid :column-num="2">
            <van-grid-item>位点携带模式</van-grid-item>
            <van-grid-item></van-grid-item>
          </van-grid>
          <!--<div>-->
            <!--<h1 class="disease_intro">疾病介绍：</h1>-->
            <!--<p class="word1">-->
              <!--FH是一种常染色体显性遗传病，是脂质代谢单基因疾病中最常见、最严重的一类，其临床特征包括高胆固醇血症、特征性黄色瘤、早发心血管疾病和阳性家族史。患者临床表现主要取决于其基因型，并具有表型异质性。纯合子较少见，其症状较杂合子重，甚至几岁时就可出现冠心病症状和体征，受体缺如的纯合子患者预后更差。-->
            <!--</p>-->
          <!--</div>-->
          <div>
            <p class="word2">您很幸运地携带了该突变，携带该突变能够降低冠心病23%的发病风险。</p>
          </div>
        </div>
        <p class="communication">*详细信息请与遗传咨询师沟通。</p>
      </div>
    </div>
</template>

<script>
import SideBar from '@/components/SideBarResults.vue'
import { Dialog } from 'vant'
export default {
  name: 'geneticReport',
  data () {
    return {
      showExist: false
    }
  },
  components: {
    SideBar,
    Dialog
  },
  methods: {
    beforeClose (action, done) {
      this.$router.push('/multiomics')
      done()
    },
    bbb () {
      Dialog.alert({
        message: '快去增加您的全基因组、外显子组、芯片数据吧',
        className: 'dialog',
        showConfirmButton: false,
        closeOnClickOverlay: true,
        overlayStyle: {
          background: '#1a56b6',
          opacity: 0.7
        },
        beforeClose: this.beforeClose
      }).then(() => {
        // on close
      })
    },
    aaa () {
      Dialog.alert({
        message: '未发现您携带心血管疾病相关的突变，其他携带情况请前往基因检测报告中查看',
        className: 'dialog',
        showConfirmButton: false,
        closeOnClickOverlay: true,
        overlayStyle: {
          background: '#1a56b6',
          opacity: 0.7
        },
        beforeClose: this.beforeClose
      }).then(() => {
        // on close
      })
    }
  },
  mounted () {
    this.aaa()
    this.bbb()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .geneticReport {
    width: 100%;
    height: 100%;
    background: #C4E3FE;
    position: relative;
    overflow: auto;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .bars {
      position: absolute;
      top: pxToRem(20px);
      right: pxToRem(30px);
    }

    .listBox {
      clear: both;
      width: 100%;
      padding: 0 pxToRem(36px);
      margin: pxToRem(92px) auto;

      .list {
        padding: pxToRem(70px);
        background: #fff;
        border-radius: pxToRem(20px);
      }

      .title {
        font-size: pxToRem(28px);
        font-weight: 400;
        color: #221815;
      }

      .disease_name {
        font-size: pxToRem(33px);
        font-weight: bold;
        color: #295CAF;
        text-align: center;
        letter-spacing: 2px;
        margin-top: pxToRem(50px);
        margin-bottom: pxToRem(43px);
      }

      .disease_intro {
        font-size: pxToRem(33px);
        font-weight: bold;
        color: #295CAF;
        letter-spacing: 2px;
        margin: pxToRem(30px) 0;
      }

      .word1 {
        font-size: pxToRem(22px);
        font-weight: 400;
        color: #221815;
        text-indent: 1em;
        letter-spacing: 1px;
      }

      .word2 {
        font-size: pxToRem(22px);
        font-weight: bold;
        color: #295CAF;
        text-indent: 1em;
        letter-spacing: 1px;
        margin: pxToRem(60px) 0;
      }

      .communication {
        font-size: pxToRem(22px);
        font-weight: 300;
        text-align: right;
        margin-top: pxToRem(33px);
        margin-right: pxToRem(27px);
      }
    }
  }
</style>
<style lang="scss">
  @import "../../assets/scss/functions";
  .geneticReport {
    .van-grid:nth-of-type(even) .van-grid-item__content {
      background: #fff;
    }
    .van-grid:nth-of-type(odd) .van-grid-item__content {
      background: #C4E3FE;
    }
  }
  .dialog {
    .van-dialog__message {
      font-size: pxToRem(28px);
      font-weight: 300;
      color: #221815;
      text-align: center;
      letter-spacing: 1px;
      line-height: pxToRem(47px);
      padding: pxToRem(120px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/genetic/geneticReport.vue